import React, { Component } from 'react'
import { Card, CardLink, CardBody, Form, Input, FormFeedback, FormGroup, Button, Label } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import validaciones from '../../Auxiliares/validaciones'
import { toast } from 'react-toastify'

export default class modModulo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            nombre: this.props.nombre,
            listaDef: Array.from(this.props.lista),
            docs: [],
            lista: [],
            errors: {}
        }
        this.handleChange = this.handleChange.bind(this)
        this.guardar = this.guardar.bind(this)
    }

    componentDidMount() {
        let list = this.props.lista;
        //Preparar listado de documentos, omitir los existentes en listaDef
        let diferenciaDocumentos = this.props.docs.filter(function (elem) {
            return !list.includes(elem);
        });

        this.setState({ docs: diferenciaDocumentos, lista: list })
    }

    setValue(field, ev) {
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch ([field].toString()) {
                case 'nombre':
                    if (validaciones.validar_titulo(this.state.nombre)) {
                        value = validaciones.validar_titulo(this.state.nombre)
                        this.setState(prevState => ({ errors: { ...prevState.errors, nombre: value } }));
                    } else {
                        this.setState({errors: (delete Array.from(this.state.errors).nombre) });
                    }
                break;

                default:
                    break;
            }
        })
    }

    handleChange = e => {
        console.log(e.target.value, e.target.checked)
        const value = e.target.value;

        if(e.target.checked){
            this.setState(prevState=>({
                lista: [...prevState.lista, value]
            }))
        }else{
            this.setState({
                lista: this.state.lista.filter((elem)=> { 
                return elem !== value
            })});
        }
    }

    guardar() {

        const { id, nombre, lista, errors } = this.state

        if (validaciones.sinErrores(errors) && this.state.lista.length > 0) {
            Fetch('/api/updateModulo', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id, nombre, lista })
            }).then(Response => {
                this.props.actualizar();
                this.props.cerrar();
            }).catch(err => {
                switch (err.status) {

                    case 600:
                        toast.error('Error inesperado')
                        break;

                    case 601:
                        toast.error('Este usuario ya existe')
                        break;

                    case 604:
                        toast.error('Este usuario no pudo ser registrado')
                        break;

                    default:
                        break;
                }
            })
        }
    }

    render() {

        return (
            <Card className="border-0">
                <CardBody>
                    <Form method="post" encType="multipart/form-data" onSubmit={(e)=>e.preventDefault()}>
                        <FormGroup >
                            <Input className="w-100 font-weight-bold" type="text" onChange={this.setValue.bind(this, 'nombre')} invalid={this.state.errors.nombre} placeholder="Nombre" name="nombre" defaultValue={this.state.nombre}/>
                            <FormFeedback>{this.state.errors.nombre}</FormFeedback>
                        </FormGroup>

                        <FormGroup>
                        {this.state.listaDef.map((item) => (
                            <div name="obj">
                                <Card className="p-3 px-3 my-1">
                                    <FormGroup className="form-check mb-2">
                                        <Label className="form-check-label">
                                            <Input type="checkbox" onChange={this.handleChange} className="form-check-input filled-in" value={item} defaultChecked />{' '}{item}
                                        </Label>
                                    </FormGroup>
                                </Card>
                            </div>
                        ))}
                        {this.state.docs.length > 0 ? this.state.docs.map((item) => (<div name="item"><Card className="p-3 px-3 my-1"><FormGroup className="form-check mb-2"><Label className="form-check-label">
                            <Input type="checkbox" onChange={this.handleChange} className="form-check-input" value={item} />{' '}{item}</Label></FormGroup></Card></div>)) : <div></div>}
                        <FormFeedback>{this.state.errors.listaDef}</FormFeedback>
                        </FormGroup>
                        <br />
                        <div className="text-center">
                            <CardLink>
                                <Button color="info" onClick={this.guardar}>Guardar</Button>
                                <Button color="white" onClick={this.props.cerrar} >Cancelar</Button>
                            </CardLink>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        )
    }
}
